@for (col of columns; track col) {
  <th [id]="col.field + '-column'" [pSortableColumn]="col.sort ? col.field : undefined"
      [ngClass]="col?.columnmHeader?.class  ? col?.columnmHeader?.class : col?.class " [ngStyle]="col?.columnmHeader?.style ? col?.columnmHeader?.style : col.style"
      class="text-center" [style.width]="col.width ? col.width : null"
      [pTooltip]="col.headerTooltip?.message ? col.headerTooltip?.message :'none'" [tooltipDisabled]="col.headerTooltip?.disabled ?? true" tooltipPosition="top">

    @if (col.headerBtn){
      <button pButton [label]="col.headerBtn.label ?? ''" [icon]="col.headerBtn.icon ?? ''" (click)="col.headerBtn.onClick($event)" [disabled]="getDisabled(col)"
            [class]=" col.class ?? 'p-button-outlined'" [outlined]="col.headerBtn.outlined ?? true" [severity]="col.headerBtn.severity?? 'primary'"></button>
    }
    @else if (tabletypeChecker.isDataColumn(col)) {
    <div class="flex align-items-center" [ngClass]="getHeaderOrientationClass(col)">
      <div [innerHTML]="col.header"></div>
      <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
      <p-columnFilter 
        *ngIf="col.columnFilter" 
        [field]="col.field" 
        display="menu"
        [matchModeOptions]="matchModeOptions"
        matchMode="contains"
        [showAddButton]="false"
        [showOperator]="false"
        [maxConstraints]="1"
      ></p-columnFilter>
    </div>
    }
    @else if (tabletypeChecker.isButtonColumn(col)) {
      @switch (col.buttonType) {
        @case (ButtonColumnType.CHECK) {
          <div class="flex align-items-center" ngClass="justify-content-center">
            <div [innerHTML]="col.header"></div>
            <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            <p-columnFilter *ngIf="col.columnFilter" [field]="col.field" display="menu"></p-columnFilter>
          </div>
        }
        @case (ButtonColumnType.TEXT) {
          <div class="flex align-items-center" ngClass="justify-content-center">
            <div [innerHTML]="col.header"></div>
            <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            <p-columnFilter *ngIf="col.columnFilter" [field]="col.field" display="menu"></p-columnFilter>
          </div>
        }
        @case(ButtonColumnType.CUSTOM){
          <div class="flex align-items-center" ngClass="justify-content-center">
            <div [innerHTML]="col.header || ''"></div>
          </div>
        }
      }

    }
  </th>
}
